import React from 'react';
import NoData from 'src/shared/components/no-data/NoData';
import { PrimaryButton } from 'src/shared/components/button/Button';
import EmptyFiles from 'src/assets/images/sites/empty-files.png';

type EmptyFilesStateProps = {
    onUploadClick: () => void;
    textContent?: string;
};

const EmptyFilesState = ({ onUploadClick, textContent = 'There are no files yet.' }: EmptyFilesStateProps) => {
    return (
        <div className='flex flex-col items-center'>
            <NoData
                text={textContent}
                footerContent={
                    <div className='flex flex-col items-center gap-4 mt-2'>
                        <div className='text-grey-80 text-center'>
                            Upload your first file, or contact our{' '}
                            <a
                                className='text-primary underline'
                                href='https://naturemetrics.atlassian.net/servicedesk/customer/portal/14'
                                target='_blank'
                                rel='noreferrer'
                            >
                                support team
                            </a>{' '}
                            if you need help.
                        </div>
                        <PrimaryButton onClick={onUploadClick} className='flex items-center gap-2'>
                            <span>Upload</span>
                            <span className='text-xl'>+</span>
                        </PrimaryButton>
                    </div>
                }
                image={EmptyFiles}
            />
        </div>
    );
};

export default EmptyFilesState;
